import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { QRCode } from "react-qrcode-logo";
import "./auditAssetTranfer.css";
import axios from "axios";

import { CompanyOptions } from "../../Data/Company";
import { DEPARTMENTS } from "../../Data/department";
import { departmentCodes } from "../../Data/departmentcode";
import { companyCodes } from "../../Data/Companycode";
import { downloadQRLabel } from "../../../utils/qrLabelPrint";

const AuditTransfer = () => {
  const location = useLocation();
  const asset = location.state?.asset; // Get asset details from navigation state
  const user = JSON.parse(localStorage.getItem("currentUser"));
  const [assetprice, setAssetPrice] = useState("");
  const [name, setName] = useState(user?.username || "");
  const [company, setCompany] = useState(asset?.company || "");
  const [department, setDepartment] = useState(asset?.department || "");
  const [assetUserName, setUserName] = useState("");
  const [assetUpdateDate, setAssetUpdateDate] = useState("");
  const [specialNote, setSpecialNote] = useState("");
  const [assetTransferDate, setTransferDate] = useState("");
   const [assetImage, setAssetImage] = useState(null);

  const [qrCodeData, setQrCodeData] = useState([]); // State to store QR codes
  const navigate = useNavigate();

  const qrCodeContainerRef = useRef(null); // Reference for QR code container

  // Function to generate tracking ID
  const generateTrackingId = (serial) => {
    const comp = companyCodes[company] || "XX";
    const dep = departmentCodes[department] || "XX";

    const serialSuffix = serial ? serial.slice(-8) : "";
    const randomNum = `${new Date()
      .toISOString()
      .slice(2, 10)
      .replace(/-/g, "")
      .slice(0, 6)}${String(Math.floor(Math.random() * 100)).padStart(2, "0")}`;

    return serial
      ? `${comp}-${dep}-${serialSuffix}`
      : `${comp}-${dep}-${randomNum}`;
  };

  // Function to generate QR code data
  const generateQRCode = () => {
    if (!company || !department) {
      alert("Please select both company and department.");
      return;
    }

    if (!assetUserName.trim()) {
      alert("Please enter the EPF No & Recipient Name");
      return;
    }

    if (!specialNote.trim()) {
      alert("Please enter the Tranfer Reason");
      return;
    }

    if (!assetTransferDate) {
      alert("Please enter the asset transfer date.");
      return;
    }

    if (!specialNote.trim()) {
      alert("Please enter the Tranfer Reason");
      return;
    }

    if (!assetTransferDate) {
      alert("Please enter the asset transfer date.");
      return;
    }

    const trackingId = generateTrackingId(asset?.serialNumber); // Generate tracking ID first
    //const youtubeURL = `https://inv.vellaglobal.com/QRView/${trackingId}`; // Now use trackingId
    const youtubeURL = `https://inv.vellaglobal.com/QRView/${trackingId}`;

    setQrCodeData([
      { component: asset?.assetName, qrData: youtubeURL, trackingId },
    ]);
  };

  // Remove this line
  // useEffect(() => { fetchUsers(); }, []);

  const handleUpdate = async () => {
    if (!asset) {
      alert("Asset not found.");
      return;
    }

    if (!company || !department) {
      alert("Please select both company and department.");
      return;
    }

    if (!assetUserName.trim()) {
      alert("Please enter the user name.");
      return;
    }

    if (!specialNote.trim()) {
      alert("Please enter the Tranfer Reason");
      return;
    }

    if (!assetTransferDate) {
      alert("Please enter the asset transfer date.");
      return;
    }
    const newtrackingId = qrCodeData[0]?.trackingId;
    const transferAsset = {
      ...asset,
      name,
      company,
      department,
      assetUserName,
      assetprice,
      assetTransferDate,
      specialNote,
      trackingId: newtrackingId,
      assetImage: assetImage ? URL.createObjectURL(assetImage) : asset.assetImage, 
    };

    try {
      // 1. Post to transfer database
      const response = await axios.post(
        `/api/transfer/transfers`,
        transferAsset,
      );

      if (response.status === 200 || response.status === 201) {
        // 2. Save original asset to beforeTransfer
        const beforeTransferAsset = { ...asset, newtrackingId };

        const backupResponse = await axios.post(
          `/api/beforeTransfer/beforetransfers`,
          beforeTransferAsset,
        );

        if (backupResponse.status === 200 || backupResponse.status === 201) {
          // 3. Delete from original asset register
          const id = asset._id;
          const deleteResponse = await axios.delete(
            `/api/AssetRegisterDetails/deleteAsset/${id}`,
          );

          if (deleteResponse.status === 200) {
            alert("Asset transferred successfully!");
            navigate("/AuditAsset");
          } else {
            alert("Asset backed up but deletion failed.");
            console.error("Delete failed:", deleteResponse);
          }
        } else {
          alert("Transfer succeeded but backup failed.");
          console.error("Backup failed:", backupResponse);
        }
      } else {
        alert("Failed to transfer asset.");
      }
    } catch (error) {
      console.error("Error in transfer flow:", error.response || error);
      alert("An error occurred while processing the transfer.");
    }
  };

  // Function to handle QR code download
  // Retained only for reference while all downloads use the standard label.
  // eslint-disable-next-line no-unused-vars
  const handleDownloadQRLegacy = (index, event) => {
    event.preventDefault();

    const canvas =
      qrCodeContainerRef.current.getElementsByTagName("canvas")[index];
    if (!canvas) return;

    const qrImage = new Image();
    qrImage.src = canvas.toDataURL("image/png");

    qrImage.onload = () => {
      const borderSize = 10; // Border thickness
      const qrSize = 80; // QR code size
      const textHeight = 32; // Space for tracking ID and scan instruction
      const width = qrSize + borderSize * 2;
      const height = qrSize + borderSize * 2 + textHeight;

      const canvasElement = document.createElement("canvas");
      const ctx = canvasElement.getContext("2d");

      canvasElement.width = width;
      canvasElement.height = height;

      // Border
      ctx.fillStyle = "#0b4c55"; // Dark teal border color
      ctx.fillRect(0, 0, width, height);

      // QR Code background (white)
      ctx.fillStyle = "#ffffff"; // White background inside the border
      ctx.fillRect(borderSize, borderSize, qrSize, qrSize);

      // Draw the QR Code
      ctx.drawImage(qrImage, borderSize, borderSize, qrSize, qrSize);

      // Add Tracking ID text below QR
      ctx.fillStyle = "#ffffff"; // Black text color
      ctx.font = "bold 10px Arial";
      ctx.textAlign = "center";
      ctx.fillText(qrCodeData[index].trackingId, width / 2, height - 17);
      ctx.font = "bold 7px Arial";
      ctx.fillText("SCAN FOR ASSET DETAILS", width / 2, height - 5);

      // Download QR code with border
      const link = document.createElement("a");
      link.href = canvasElement.toDataURL("image/png");
      link.download = `QR_Code_${qrCodeData[index].trackingId}.png`;
      link.click();
    };
  };

  const handleDownloadQR = async (index, event) => {
    event.preventDefault();
    try {
      await downloadQRLabel({
        ...asset,
        company: company || asset?.company,
        trackingId: qrCodeData[index]?.trackingId,
      });
    } catch (error) {
      alert(error.message || "Unable to download the QR label.");
    }
  };

  return (
    <div className="transfer-container">
      <h2 className="trnshead">Transfer Asset</h2>
      <form className="transfer-form">
        <div className="row">
          <div className="form-group col-md-4">
            <label className="iclabel">
              <i class="fa fa-arrow-right-arrow-left"></i> Transfer Name
            </label>
            <input
              className="in1"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your Name"
              readOnly={Boolean(user)}
            />
          </div>

          <div className="form-group col-md-4">
            <label className="iclabel">
              <i class="fa fa-align-center"></i> Category
            </label>
            <input
              className="in1"
              type="text"
              value={asset?.category || ""}
              readOnly
            />
          </div>

          <div className="form-group col-md-4">
            <label className="iclabel">
              <i class="fa fa-list"></i> Type
            </label>
            <input
              className="in1"
              type="text"
              value={asset?.type || ""}
              readOnly
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-4">
            <label className="iclabel">
              <i className="fas fa-layer-group"></i> Asset Name/Brand
            </label>
            <input
              className="in1"
              type="text"
              value={asset?.assetName || ""}
              readOnly
            />
          </div>

          <div className="form-group col-md-4">
            <label className="iclabel">
              <i class="fa fa-gear"></i> Serial Number
            </label>
            <input
              className="in1"
              type="text"
              value={asset?.serialNumber || ""}
              readOnly
            />
          </div>

          <div className="form-group col-md-4">
            <label className="iclabel">
              <i className="fa fa-suitcase"></i> Asset Model
            </label>
            <input
              className="in1"
              type="text"
              value={asset?.assetModel || ""}
              readOnly
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <label className="iclabel">
              <i class="fa fa-building"></i> Company
            </label>
            <input className="in1" value={company} readOnly />
          </div>

          <div className="col-md-6">
            <label className="iclabel">
              <i class="fa fa-building"></i> Department
            </label>
            <input className="in1" value={department} readOnly />
          </div>
        </div>
        <div>
          <label className="iclabel">
            <i className="fas fa-handshake-angle"></i> EPF No & Recipient Name
          </label>
          <input
            className="tIn"
            type="text"
            value={assetUserName}
            onChange={(e) => setUserName(e.target.value)}
            placeholder="Eg: 53 Pasindu Lakshan"
          />
        </div>
        <div>
          <label className="iclabel">
            <i class="fa fa-comment-dollar"></i> Price
          </label>
          <input
            className="tIn"
            type="text"
            value={assetprice}
            onChange={(e) => setAssetPrice(e.target.value)}
            placeholder="Enter Asset Price (Rs)"
          />
        </div>
        <div>
          <label className="iclabel">
            <i class="fa fa-calendar-check"></i> Asset Transfer Date
          </label>
          <input
            className="dat"
            type="date"
            value={assetTransferDate}
            onChange={(e) => setTransferDate(e.target.value)}
          />
        </div>
        <div>
          <label className="iclabel">
            <i className="fa fa-clipboard"></i> Tranfer Reason
          </label>
          <input
            className="tIn"
            type="text"
            value={specialNote}
            onChange={(e) => setSpecialNote(e.target.value)}
            placeholder="Enter Tranfer Reason"
          />
        </div>

        <div className="invoice-upload">
                  <label htmlFor="assetImage" className="upload-card">
                    {!assetImage ? (
                      <>
                        <i className="fa fa-image upload-icon"></i>
                        <p className="upload-title">Upload Asset Image</p>
                        <span className="upload-subtitle">
                          Camera or Gallery
                        </span>
                      </>
                    ) : (
                      <div className="preview-container">
                        <img
                          src={URL.createObjectURL(assetImage)}
                          alt="Asset"
                        />
                        <span className="uploaded-badge">Uploaded</span>

                        <button
                          type="button"
                          className="remove-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setAssetImage(null);
                          }}
                        >
                          ✕
                        </button>
                      </div>
                    )}
                  </label>

                  <input
                    id="assetImage"
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(e) => setAssetImage(e.target.files[0])}
                  />
                </div>
        <div>
          <button type="button" className="button" onClick={generateQRCode}>
            Generate QR
          </button>
        </div>

        <div ref={qrCodeContainerRef}>
          {qrCodeData.map((item, index) => (
            <div key={index} className="combined-qr-container">
              <div className="qr-code">
                <QRCode value={item.qrData} size={100} />
                <p className="tid">{item.trackingId}</p>
              </div>
              <button
                className="button2 download-btn"
                onClick={(e) => handleDownloadQR(index, e)}
              >
                <i className="fas fa-download"></i>
              </button>
            </div>
          ))}
        </div>
        {qrCodeData.length > 0 && (
          <div>
            <button
              type="button"
              onClick={handleUpdate}
              className="transfer-button"
            >
              Transfer
            </button>
          </div>
        )}
      </form>
    </div>
  );
};

export default AuditTransfer;
